import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    minWidth: '500px',
    margin: '0 auto',
  },
};
const NpaWidget = () => (

  <div id="npaWidget_Container" style={styles.container} />

);

export default NpaWidget;
